module.exports = __webpack_public_path__ + "static/arrow-right.d0e8c1e8.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/arrow-right.png
// module id = 279
// module chunks = 2